import styled from 'styled-components';

export const Body = styled.p`
  color: ${({ theme }) => theme.middleGrey};
  font-size: 16px;
  font-weight: ${({ theme }) => theme.fontWeight.regular};
  line-height: 24px;
  margin: 0;
`;
